import { formatAssistantRoomsOccupancyText } from 'tripPlanner/assistant/utils/assistantRoomOccupancyText'

export interface ExperienceSearchDateRange {
  checkIn?: string
  checkOut?: string
}

function formatDateRangeSuffix({ checkIn, checkOut }: ExperienceSearchDateRange): string {
  return checkIn && checkOut ? `, ${checkIn} to ${checkOut}` : ''
}

// Included so a rooms-only reapply (same destination/dates, different occupancy) produces a
// displayText distinct from the original search -- otherwise the two are indistinguishable and
// the server's kind+displayText grouping silently absorbs the occupancy change into the earlier
// entry, losing the fact that the customer changed party size at all.
function formatOccupancySuffix(occupancies: Array<App.Occupants>): string {
  const occupancyText = formatAssistantRoomsOccupancyText(occupancies)
  return occupancyText ? `, ${occupancyText}` : ''
}

// Shared by both the activity entry (`experience_search_submitted`) and the committed-state entry
// (`last_experience_search`) -- same underlying search, same customer-facing summary, so one
// composer rather than two copies that could silently drift apart.
export function formatExperienceSearchDisplayText(
  searchQuery: string,
  dateRange: ExperienceSearchDateRange,
  occupancies: Array<App.Occupants>,
): string {
  return `Searched experiences for "${searchQuery}"${formatDateRangeSuffix(dateRange)}${formatOccupancySuffix(occupancies)}`
}
